import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Documento, ProcessoRiferimento } from '../models/data.model';
import { CommonService } from './common.service';


@Injectable({
  providedIn: 'root'
})
export class EqualtecService {

  private detail = new BehaviorSubject<boolean>(false);
  isDetail = this.detail.asObservable();
  private favorites = new BehaviorSubject<boolean>(false);
  isFavorites = this.favorites.asObservable();
  private evidence = new BehaviorSubject<boolean>(false);
  isEvidence = this.evidence.asObservable();
  private link = new BehaviorSubject<boolean>(false);
  isLink = this.link.asObservable();
  private search = new BehaviorSubject<boolean>(false);
  isSearch = this.search.asObservable();
  private filtraCompliance = new BehaviorSubject<boolean>(false);
  isFiltraCompliance = this.filtraCompliance.asObservable();

  public isCompliance: boolean = false;
  public isEvidenzaPrecedente: boolean = false;
  public nomeProcessoRiferimento: string = ""
  public selectedLegalEntity: string = "QA Esaote SpA";
  public documents: Documento[] = [];
  public selectedDocument: Documento = {} as Documento;
  public processiSopra: ProcessoRiferimento[] = [];
  public processiCentrale: ProcessoRiferimento[] = [];
  public processiSotto: ProcessoRiferimento[] = [];
  public processi: ProcessoRiferimento[] = [];

  constructor(
    private documentService: CommonService<Documento>,
  ) { }

  openCompliance() {
    this.filtraCompliance.next(true);
  }

  openDetail(processo: string) {
    this.nomeProcessoRiferimento = processo;
    this.isEvidenzaPrecedente = false;
    this.favorites.next(false);
    this.evidence.next(false);
    this.link.next(false);
    this.search.next(false);
    this.detail.next(true);
  }

  openEvidence(doc: Documento, isEvidenzaPrecedente: boolean) {
    this.isEvidenzaPrecedente = isEvidenzaPrecedente;
    this.selectedDocument = doc;
    this.link.next(false);
    this.evidence.next(true);
  }

  openSearch() {
    this.isEvidenzaPrecedente = false;
    this.favorites.next(false);
    this.evidence.next(false);
    this.detail.next(false);
    this.link.next(false);
    this.search.next(true);
  }

  closeEvidence() {
    this.isEvidenzaPrecedente = false;
    this.evidence.next(false);
  }

  openLink(doc: Documento) {
    this.selectedDocument = doc;
    this.evidence.next(false);
    this.link.next(true);
  }

  closeLink() {
    this.link.next(false);
  }

  openFavorites() {
    this.isEvidenzaPrecedente = false;
    this.detail.next(false);
    this.evidence.next(false);
    this.search.next(false);
    this.link.next(false);
    this.favorites.next(true);
  }

  goToHome() {
    this.isEvidenzaPrecedente = false;
    this.favorites.next(false);
    this.detail.next(false);
    this.search.next(false);
    this.link.next(false);
    this.evidence.next(false);
  }

  GestisciPreferiti = (doc: Documento, add: boolean) => {
    var url = 'api/rest/'
    if (add) {
      url += 'SetDocumentiPreferiti';
    }
    else {
      url += 'UnSetDocumentiPreferiti';
    }
    const input = { idDocumento: doc.idDocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        doc.isDocPreferito = add;
        console.log("Preferite " + doc.idDocumento + " Added");
      }
    })
  }

}
